export default {
    token: "https://find-a-mentor-app-default-rtdb.asia-southeast1.firebasedatabase.app/",
    apiKey: "AIzaSyBneTW14CGN7pr56airynfP7GiKEx5c9Mo"
}